import React from "react";
import { useLocation } from "react-router-dom";
import CartRecoveryDetailPage from "./CartRecoveryDetailPage";

const CartRecoveryDetailWrapper = () => {
  const location = useLocation();
  const initialRule = location.state?.rule;

  return <CartRecoveryDetailPage initialRule={initialRule} />;
};

export default CartRecoveryDetailWrapper;
